var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_908_49)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "black",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_908_49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 12C15 10.8233 14.32 9.80667 13.3333 9.31667V10.79L14.97 12.4267C14.99 12.2867 15 12.1433 15 12ZM16.6667 12C16.6667 12.6267 16.53 13.2167 16.3067 13.76L17.3167 14.77C17.75 13.94 18 13 18 12C18 9.14667 16.0033 6.76 13.3333 6.15333V7.53C15.26 8.10333 16.6667 9.88667 16.6667 12ZM6.85 6L6 6.85L9.15 10H6V14H8.66667L12 17.3333V12.85L14.8367 15.6867C14.39 16.03 13.8867 16.3067 13.3333 16.4733V17.85C14.2345 17.6431 15.0754 17.2301 15.79 16.6433L17.15 18L18 17.15L12 11.15L6.85 6ZM12 6.66667L10.6067 8.06L12 9.45333V6.66667Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_908_49",
    x: -4,
    y: -4,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_908_49"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_908_49",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_908_49"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.e7db4cfa3682e82c6a133e017915f3e3.svg";
export { ForwardRef as ReactComponent };